// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectMessageBase } from './DirectMessageBase.ts'
import { SessionOperations } from '../../Utils/Enums/Constants.js'
import { DirectMessageCode } from './DirectMessageCodes.ts'

export let DirectTradeSessionStatusMessage = function ()
{
    DirectMessageBase.call(this, DirectMessageCode.CODE_TRADE_SESSION_STATUS_MESSAGE)
    this.Id = 0
    this.Name = null
    this.AllowedOrderTypes = []
    this.AllowedOperations = SessionOperations.None
    this.IsDecreaseOnlyPositionCount = false
}

DirectTradeSessionStatusMessage.prototype = Object.create(DirectMessageBase.prototype)